import React from "react";

const PopUpScreenTitle = ({
  title,
  hederDetails,
  sideHeader,
  setpopUpOpen,
  viewDetails,
  deleteDetails,
  uploadDetails,
  blockDetails,
  unBlockDetails,
  titleColorstatus=false,
  clearData

}) => {
  const titleColor ={
    textColor:`${ titleColorstatus?"text-green-400 text-xl font-medium":"text-xl font-medium  text-white"}`
    
  }
    // New function to handle close and clear
  const handleClose = () => {
    if (clearData) clearData();
    setpopUpOpen(false);
  };
  return (
   
    <div className="p-2">
      <button className="w-full flex justify-between items-center rounded bg-black px-2 py-2">
        <span className={titleColor.textColor}>
          {hederDetails && `${title}`}
          {viewDetails && `${title} - View`}
          {deleteDetails && `${title} - Delete`}
          {blockDetails && `${title} - Make Inactive`}
          {unBlockDetails && `${title} - Make Active`}
          {uploadDetails && `${title} - Upload Invoices`}
        </span>
        <span
          className="text-2xl text-white cursor-pointer"
         onClick={handleClose}
        >
          &times;
        </span>
      </button>
      <div className="text-md font-medium text-block px-2 py-1">
        {sideHeader && `${sideHeader}`}

      </div>
    </div>
  );
};

export default PopUpScreenTitle;
